import {
    TASK_LIST,
    TASK_LIST_SUCCESS,
    TASK_LIST_ERROR,
    TASK_PAGE_SET,
    TASK_DETAIL,
    TASK_DETAIL_SUCCESS,
    TASK_DETAIL_ERROR,
    TASK_VIEW_MODAL_SET,
    TASK_DETAIL_LIST,
    TASK_DETAIL_LIST_SUCCESS,
    TASK_DETAIL_LIST_ERROR,
    TASK_DETAIL_ADD,
    TASK_DETAIL_ADD_SUCCESS,
    TASK_DETAIL_ADD_ERROR,
    TASK_DETAIL_ADD_CHANGE
} from '../actions';

const INIT_STATE = {
    loading: true,
    error: false,
    list: {
        page: { current: 1, rows: 10 },
        data: [],
        total_pages: 0,
        total_item: 0,
        first_page: 0,
        last_items: 0
    },
    detail: {
        data: {},
        loading: false
    },
    view: {
        modal: false
    },
    taskDetail: {
        list: { data: [] },
        add: {
            loading: false,
            id: null,
            data: { new: { description: '' } }
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case TASK_LIST:
            return { ...state, loading: true };
        case TASK_LIST_SUCCESS:
            return { ...state, loading: false, list: { ...state.list, ...action.payload } };
        case TASK_LIST_ERROR:
            return { ...state, loading: false, error: true };
        case TASK_PAGE_SET:
            return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
        case TASK_DETAIL:
            return { ...state, detail: { ...state.detail, loading: true, data: {} } };
        case TASK_DETAIL_SUCCESS:
            return { ...state, detail: { ...state.detail, loading: false, data: action.payload } };
        case TASK_DETAIL_ERROR:
            return { ...state, detail: { ...state.detail, loading: false, data: {} } };
        case TASK_VIEW_MODAL_SET:
            return { ...state, view: { ...state.view, modal: action.payload } };
        case TASK_DETAIL_LIST:
            return { ...state, taskDetail: { ...state.taskDetail, list: { ...state.taskDetail.list } } };
        case TASK_DETAIL_LIST_SUCCESS:
            return { ...state, taskDetail: { ...state.taskDetail, list: { data: action.payload } } };
        case TASK_DETAIL_LIST_ERROR:
            return { ...state, taskDetail: { ...state.taskDetail, list: { data: [] } } };
        case TASK_DETAIL_ADD:
            return { ...state, taskDetail: { ...state.taskDetail, add: { ...state.taskDetail.add, loading: true } } };
        case TASK_DETAIL_ADD_SUCCESS:
            return { ...state, taskDetail: { ...state.taskDetail, add: { ...state.taskDetail.add, loading: false, id: action.payload, data: { new: { description: '' } } } } };
        case TASK_DETAIL_ADD_ERROR:
            return { ...state, taskDetail: { ...state.taskDetail, add: { ...state.taskDetail.add, loading: false } } };
        case TASK_DETAIL_ADD_CHANGE:
            return { ...state, taskDetail: { ...state.taskDetail, add: { ...state.taskDetail.add, data: { new: { ...state.taskDetail.add.data.new, ...action.payload } } } } };
        default:
            return state;
    }
};
